// EN
export const availabilityPrices = {
  header: {
    title: "Disponibilité et tarifs",
  },
  common: {
    today: "Aujourd'hui",
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement…",
  },
  pricelabs: {
    title: "Les tarifs sont gérés par PriceLabs",
    text: "Les tarifs sont mis à jour automatiquement et ne peuvent pas être modifiés manuellement.",
  },
  topbar: {
    calendar: "Calendrier",
    bulkEdit: "Édition groupée",
    configTitle: "Paramètres du calendrier",
    syncSection: "Synchronisation",
    resyncOta: "Resynchroniser avec l'OTA",
    resyncOtaDesc: "Renvoie la disponibilité et les tarifs au canal.",
  },
  empty: {
    noHotelTitle: "Aucun hébergement de type hôtel",
    noHotelDesc:
      "Créez un hébergement de type <strong>Hôtel</strong> ou <strong>Camping</strong> pour commencer à gérer la disponibilité et les tarifs.",
    goToListings: "Accéder aux hébergements",
    noRoomsTitle: "{name} n'a aucune chambre",
    noRoomsDesc:
      "Cet hébergement n'a encore aucune chambre enregistrée. Ajoutez des unités depuis le détail de l'hébergement pour gérer la disponibilité et les tarifs.",
    configureListing: "Configurer l'hébergement",
  },
  summary: {
    roomState: "État des chambres",
    roomsForSale: "Chambres en vente",
    netBooked: "Réservations nettes",
  },
  state: {
    available: "Disponible",
    closed: "Fermé",
    soldOut: "Complet",
    pastLabel: "N/D",
  },
  calendar: {
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of rooms / nights
    roomsCount: "{count} chambre | {count} chambres",
    minStayTooltip: "Séjour minimum : {count} nuit | Séjour minimum : {count} nuits",
  },
  offBadge: "ARRÊTÉ",
  offTooltip: "Vente arrêtée : ce tarif n’est proposé sur aucun canal. Les autres tarifs de la chambre restent en vente.",
  rateMenu: {
    open: "Options du tarif",
    minStay: "Séjour minimum par dates",
    priceLabsMinStay: "Ce tarif est géré par PriceLabs : c’est lui qui fixe le séjour minimum.",
    stopSelling: "Arrêter la vente de ce tarif",
    stopping: "Arrêt de la vente…",
    resuming: "Réactivation de la vente…",
    resumeSelling: "Reprendre la vente de ce tarif",
    derivedPriceHint: "Le prix d’un tarif dérivé vient de son parent",
    mainKeepsDerived: "Ses tarifs dérivés resteront en vente",
    mainNotYet: "Fermer un tarif principal n’est pas encore disponible",
  },
  derived: {
    badge: "D",
    tooltip: "Tarif dérivé de : {parent}{rule}",
    rulePart: " · Règle : {rule}",
  },
  tooltips: {
    syncEnabled:
      "Recalcule et renvoie la disponibilité et le séjour maximum à l'OTA (évite le surbooking).",
    syncDisabled: "Connectez l'établissement à un canal pour activer la synchronisation.",
    toggleClosedOpen: "Basculer fermé/ouvert",
    managedByPricelabs: "Géré par PriceLabs",
    clickToEdit: "Sélectionnez ou cliquez pour modifier",
  },
  cellTitle: {
    pastDate: "Date passée",
    closed: "Fermé (cliquez pour ouvrir)",
    detail:
      "{free} libres · {tope} sur {total} proposées · {booked} réservées — cliquez pour modifier le plafond",
  },
  soldBadge: {
    confirmed: "{real} réservations confirmées",
    withOverbooking: "{real} confirmées + {over} en surbooking",
  },
  bulkModal: {
    from: "Du",
    to: "Au",
    rangeHint:
      "Vous pouvez modifier la plage ici pour l'étendre ou l'ajuster. (La vue ne mettra à jour visuellement que le mois en cours.)",
    room: "Chambre",
    whatToEdit: "Que modifier",
    optAvail: "Disponibilité et fermetures",
    optRate: "Tarifs et séjour minimum",
    status: "Statut",
    open: "Ouvrir",
    close: "Fermer",
    cap: "plafond",
    availHint:
      "Il s'agit du total que vous proposez ; les réservations sont déduites automatiquement et seules les chambres libres sont vendues. Max. {max} (opérationnelles, hors maintenance).",
    mainRate: "Tarif principal",
    mainRateHint:
      "Choisissez le tarif principal à modifier ; ses tarifs dérivés s'ajustent automatiquement.",
    action: "Action",
    price: "Prix",
    minStay: "Séjour minimum",
    minStayNights: "Séjour minimum (nuits)",
    minStayHelp: "1 = aucune restriction (vider)",
  },
  syncConfirm: {
    title: "Synchroniser avec l'OTA",
    message:
      "Cela recalculera et renverra la disponibilité et le séjour maximum de ce calendrier à l'OTA.",
    confirm: "Oui, synchroniser",
  },
  progress: {
    processing: "Traitement…",
    syncing: "Synchronisation du calendrier avec l'OTA…",
    updatingAvail: "Mise à jour de la disponibilité…",
    updatingRate: "Mise à jour du tarif…",
    applying: "Application des modifications…",
    applyingBulk: "Application de l'édition groupée…",
    applyingIn: "Application à {name}…",
  },
  toasts: {
    noPropertyToSync: "Aucun établissement à synchroniser.",
    syncOk: "Calendrier recalculé et synchronisé avec l'OTA.",
    syncErr: "Impossible de synchroniser le calendrier avec l'OTA.",
    loadErr: "Impossible de charger les informations de l'hôtel.",
    maxAvailClosedBlocked:
      "Disponibilité maximale : {capacity} (des chambres sont fermées, bloquées ou en maintenance).",
    availUpdated: "Disponibilité mise à jour",
    availUpdateErr: "Impossible de mettre à jour la disponibilité",
    freeSuffix: " (libres : {free})",
    rateUpdated: "Tarif mis à jour",
    rateUpdateErr: "Impossible de mettre à jour le tarif",
    maxAvailMaintenance:
      "Disponibilité maximale : {capacity} (des chambres sont en maintenance ou hors service).",
    noDatesModifiedBooked: "Aucune date n'a été modifiée : {count} avec des réservations.",
    appliedFreeDates:
      "Appliqué aux dates libres. {count} date(s) avec des réservations n'ont pas été modifiées.",
    changesApplied: "Modifications appliquées avec succès",
    savedNotSyncedYet: "Enregistré ici, mais pas encore arrivé aux canaux de vente. Une nouvelle tentative aura lieu dans quelques minutes.",
    cannotEditDerivedPricelabs:
      "Vous ne pouvez pas modifier un tarif dérivé ou géré par PriceLabs.",
    minStayNumberGte1: "Le séjour minimum doit être un nombre >= 1.",
    invalidAction: "Action non valide.",
    applyErr: "Impossible d'appliquer les modifications",
    noRoomsToEdit: "Il n'y a aucune chambre à modifier.",
    selectAtLeastOneRoom: "Sélectionnez au moins une chambre.",
    chooseAction: "Choisissez une action.",
    selectDateRange: "Sélectionnez une plage de dates.",
    enterValidPrice: "Saisissez un prix valide.",
    minStayGte1: "Le séjour minimum doit être >= 1.",
    appliedWithErrors: "Appliqué à {ok} chambre(s). {failed} avec une erreur",
    noDatesModifiedCapacity:
      "Aucune date n'a été modifiée : {count} jour(s) ne permettaient pas ce nombre de chambres.",
    bulkAppliedClamped:
      "Édition groupée appliquée à {ok} chambre(s). Sur {clamped} date(s), elle a été ajustée au nombre de chambres en service.",
    bulkApplied: "Édition groupée appliquée à {ok} chambre(s).",
    bulkApplyErr: "Impossible d'appliquer l'édition groupée.",
    applyChangesErr: "Impossible d'appliquer les modifications.",
  },
  // Decorative (aria-hidden) empty-state content
  ghost: {
    month: "MAI 2026",
    day1: "Lun 1",
    day2: "Mar 2",
    day3: "Mer 3",
    day4: "Jeu 4",
    day5: "Ven 5",
    day6: "Sam 6",
    day7: "Dim 7",
    day8: "Lun 8",
    day9: "Mar 9",
    day10: "Mer 10",
    day11: "Jeu 11",
    day12: "Ven 12",
    unit1: "Suite Deluxe",
    unit1Rooms: "(2 chambres)",
    unit2: "Chambre Standard",
    unit2Rooms: "(3 chambres)",
    baseRate: "Tarif de base",
    nonRefundable: "Non remboursable",
  },
};
